"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderCurrency = void 0;
const getOrderLineCurrency_1 = require("./getOrderLineCurrency");
const getOrderCurrency = (order) => {
    if (!order)
        return " - ";
    if (!order.order_lines || order.order_lines.length === 0)
        return " - ";
    for (const orderLine of order.order_lines) {
        if (orderLine) {
            const currency = (0, getOrderLineCurrency_1.getOrderLineCurrency)(orderLine);
            if (currency) {
                return currency;
            }
        }
    }
    return " - ";
};
exports.getOrderCurrency = getOrderCurrency;
